export const SHAREPOINT_SETTINGS_PATH = '/settings/integrations/sharepoint';
export const SHAREPOINT_CALLBACK_PATH = '/settings/integrations/sharepoint/callback';
